"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _entitiesSelectors = require("settings-ui-modules/marketing/modules/form/selectors/entitiesSelectors");

var _stagedSelectors = require("settings-ui-modules/marketing/modules/form/selectors/stagedSelectors");

var _constants = require("settings-ui-sdk/FormSettings/constants");

var properties = [_constants.FORM_CREATE_EMAILLESS_CONTACT_ENABLED, _constants.FONT_FAMILY, _constants.LABEL_TEXT_COLOR, _constants.LABEL_TEXT_SIZE, _constants.SUBMIT_FONT_COLOR, _constants.SUBMIT_COLOR, _constants.SUBMIT_ALIGNMENT];

var _default = new _StagedObject.default({
  domainSelector: _entitiesSelectors.getFormSettings,
  stagedSelector: _stagedSelectors.getUpdateFormSettings,
  namespace: 'form',
  objectType: _constants.FORM_SETTINGS,
  properties: properties
});

exports.default = _default;
module.exports = exports.default;